import useSEO from '@/hooks/useSEO';
import { faqList } from '@/mocks/site';
import { topics } from '@/mocks/topics';
import BreakingTicker from '@/pages/home/components/BreakingTicker';
import HeroSection from '@/pages/home/components/HeroSection';
import FreshFeed from '@/pages/home/components/FreshFeed';
import RankingBoard from '@/pages/home/components/RankingBoard';
import BreakingTimeline from '@/pages/home/components/BreakingTimeline';
import HotTopics from '@/pages/home/components/HotTopics';
import FaqSection from '@/components/feature/FaqSection';

const DOMAIN = 'https://jianxiaoer.cn';

export default function Home() {
  useSEO({
    title: '爆料前线 - 实时热点追踪与突发新闻速递平台',
    description:
      '爆料前线把今日鲜料、突发新闻和全网热搜榜集中进同一屏，实时追踪热议话题与事件进展，吃瓜闲逛、跟进舆情都不用再切换多个 App。',
    keywords: '爆料平台,实时热点,突发新闻,今日猛料,全网热搜,热议排行',
    path: '/',
    ogType: 'website',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '爆料前线',
        url: `${DOMAIN}/`,
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${DOMAIN}/ranking?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '爆料前线',
        url: `${DOMAIN}/`,
        email: 'news@baoliaopai.example.com',
        description: '实时热点追踪与突发新闻速递平台，把今日鲜料、突发新闻与热搜排行集中进同一屏。',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqList.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: { '@type': 'Answer', text: item.answer },
        })),
      },
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: '今日热议话题',
        itemListElement: topics.slice(0, 6).map((topic, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          url: `${DOMAIN}/topic/${topic.slug}`,
          name: topic.title,
        })),
      },
    ],
  });

  return (
    <>
      <BreakingTicker />
      <HeroSection />
      <FreshFeed />
      <RankingBoard />
      <BreakingTimeline />
      <HotTopics />
      <FaqSection items={faqList} />
    </>
  );
}